import { useCallback, useEffect, useState } from 'react';
import { API_URL } from '../api/config';

export interface ReportStats {
  totalAccesses: number;
  totalRegistrations: number;
  totalCheckins: number;
  totalCheckinsToday: number;
  averageStayTime?: string;
}

export const useReportStats = () => {
  const [stats, setStats] = useState<ReportStats>({
    totalAccesses: 0,
    totalRegistrations: 0,
    totalCheckins: 0,
    totalCheckinsToday: 0,
    averageStayTime: undefined,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadStats = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      // Buscar estatísticas do endpoint que já retorna todos os dados
      const response = await fetch(`${API_URL}registration/stats`);

      if (!response.ok) {
        throw new Error(`Erro ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();

      setStats({
        totalAccesses: data.totalAccesses || 0,
        totalRegistrations: data.totalRegistrations || 0,
        totalCheckins: data.totalCheckins || 0,
        totalCheckinsToday: data.totalCheckinsToday || 0,
        averageStayTime: undefined, // Pode ser implementado no backend
      });
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Erro ao carregar estatísticas';
      setError(errorMessage);
      console.error('Erro ao carregar estatísticas:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  const refresh = useCallback(() => {
    loadStats();
  }, [loadStats]);

  // Carregamento inicial
  useEffect(() => {
    loadStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    stats,
    loading,
    error,
    refresh,
  };
};
